import { cn } from "@/lib/utils";

export interface ATargetItem {
  code: string;
  behaviour: string;
  exampleWording: string | null;
  strength: string;
}

/** Read-only A-component targets with their behaviour and example wording shown inline. */
export function ATargetList({ targets }: { targets: ATargetItem[] }) {
  if (targets.length === 0) return null;
  return (
    <div>
      <p className="mb-2 font-medium text-gray-700 text-sm">A-Component Targets</p>
      <ul className="space-y-2">
        {targets.map((t) => (
          <li key={t.code} className="flex items-start gap-3 text-xs">
            <span
              className={cn(
                "shrink-0 rounded-md px-2.5 py-1 font-semibold",
                t.strength === "primary"
                  ? "bg-indigo-600 text-white"
                  : "border border-indigo-400 bg-white text-indigo-700"
              )}
            >
              {t.code}
            </span>
            <div className="pt-0.5">
              {t.behaviour && <p className="text-gray-700">{t.behaviour}</p>}
              {t.exampleWording && <p className="text-gray-500 italic">"{t.exampleWording}"</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
